module.exports = __webpack_public_path__ + "media/images/shark/Naranjo_9252-1-p-800-80ca30ec90827ce2e8b10e982e066442.jpeg";